import { MtAccountPackage, MtDriveFile } from "server/models"
import { LangIndex, ThemeType } from "client/utils"
import {
    PackageSettings,
    AccountSettings,
    UserSettings,
    PackageUsage,
} from "client/store"
import {
    AccountPermissions,
    ProjectPermissions,
    CommonPermissions,
} from "client/store/utils"
import Lang from "client/store/lang"

export type LangKey = keyof typeof Lang
export type LangType = { [key in LangKey]?: string }
export type TranslationList = { [key in LangIndex]?: LangType }

export interface UserData {
    userId: number
    userName: string
    userLogo: MtDriveFile
    userEmail: string
    accountId: number
    accountName: string
    accountLogo: MtDriveFile
    sessionId: string
}

interface ModalBase {
    onClose?: () => void
}
export interface ModalWithUrl extends ModalBase {
    url: string
}
export interface ModalWithContent extends ModalBase {
    key: string
    content: JSX.Element
}
export type ModalParams = ModalWithUrl | ModalWithContent;

export interface System {
    userData: UserData
    userGroups: readonly number[]
    projectUserGroups: { [projectId: number]: readonly number[] }

    packageActive: MtAccountPackage
    packageSettings: PackageSettings
    packageUsage: PackageUsage

    accountSettings: AccountSettings
    userSettings: UserSettings

    accountPermissions: AccountPermissions
    projectPermissions: { [projectId: number]: ProjectPermissions }
    lifecyclePermissions: CommonPermissions

    lostServerConnection: boolean

    theme: ThemeType
    lang: LangType
    langReport: LangType

    urlOrigin: string
    modals: ModalParams[]

    renderContent: boolean
    renderProjectContent: boolean
}

export const SYSTEM_USER_DATA = "SYSTEM_USER_DATA"
export const SYSTEM_USER_GROUPS = "SYSTEM_USER_GROUPS"
export const SYSTEM_PROJECT_USER_GROUPS = "SYSTEM_PROJECT_USER_GROUPS"
export const CLEAR_SYSTEM_USER_DATA = "CLEAR_SYSTEM_USER_DATA"

export const SYSTEM_PACKAGE_ACTIVE = "SYSTEM_PACKAGE_ACTIVE"
export const SYSTEM_PACKAGE_SETTINGS = "SYSTEM_PACKAGE_SETTINGS"
export const SYSTEM_PACKAGE_USAGE = "SYSTEM_PACKAGE_USAGE"
export const SYSTEM_PACKAGE_USAGE_SIL_CALCULATIONS = "SYSTEM_PACKAGE_USAGE_SIL_CALCULATIONS"

export const SYSTEM_ACCOUNT_SETTINGS = "SYSTEM_ACCOUNT_SETTINGS"
export const SYSTEM_USER_SETTINGS = "SYSTEM_USER_SETTINGS"

export const SYSTEM_ACCOUNT_PERMISSIONS = "SYSTEM_ACCOUNT_PERMISSIONS"
export const SYSTEM_PROJECT_PERMISSIONS = "SYSTEM_PROJECT_PERMISSIONS"
export const SYSTEM_LIFECYCLE_PERMISSIONS = "SYSTEM_LIFECYCLE_PERMISSIONS"

export const SYSTEM_LOST_SERVER_CONNECTION = "SYSTEM_LOST_SERVER_CONNECTION"

export const SYSTEM_THEME = "SYSTEM_THEME"
export const SYSTEM_LANG = "SYSTEM_LANG"
export const SYSTEM_LANG_REPORT = "SYSTEM_LANG_REPORT"

export const URL_ORIGIN = "URL_ORIGIN"
export const ADD_MODAL = "ADD_MODAL"
export const CLOSE_MODAL = "CLOSE_MODAL"
export const UPDATE_MODAL_URL = "UPDATE_MODAL_URL"

export const RENDER_CONTENT = "RENDER_CONTENT"
export const RENDER_PROJECT_CONTENT = "RENDER_PROJECT_CONTENT"
